import {useState, useEffect} from 'react';
import { Grid, Typography, Divider, Button } from '@mui/material';

import ManageProductsProduct from './ManageProductsProduct';
import PharmaorderPageEditProduct from 'components/pharmaorder/page/PharmaorderPageEditProduct';
import EditOrderStory from 'story/EditOrderStory';
export default function ManageProductsActionImpl(){

    return (
        <>
        <EditOrderStory/>
        </>
    )
}